/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Breadcrumb from './Breadcrumb';
import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Examination from "./Examination";
import LoadingAlert from "./LoadingAlert";
import Patient from "./Patient";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Link } from 'react-router-dom';
import Card from './Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

class ExaminationPatient extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: { examination: {} },
            examinationID: 0,
            patient: null,
            list: []
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.params.examinationID !== this.props.params.examinationID)
            this.load();
    }

    load() {
        if (this.props.params.patientID) {
            qreq.get('/api/patient/get/' + this.props.params.patientID, j => {
                if (j.item) {
                    this.setState({ patient: j.item });
                    qreq.get('/api/examination/list/patient/' + j.item.id, k => {
                        if (k.list)
                            this.setState({ list: k.list });
                    });
                }
                else if (j.errorCode)
                    this.alert(j.errorMessage);
                this.setState({ loaded: true });
            }, () => {
                this.setState({ loaded: true });
            });

        }
        if (this.props.params.examinationID) {
            qreq.get('/api/examination/get/' + this.props.params.examinationID, j => {
                if (j.errorCode === 3) {
                    this.setState({ loaded: true });
                }
                else if (j.item) {
                    if (j.item.riskTab && this.props.params.tab !== j.item.riskTab)
                        this.props.navigate('/examination/view/' + this.props.params.patientID + '/' + this.props.params.examinationID + '/' + j.item.riskTab, { replace: true });
                    try {
                        j.item.examination = JSON.parse(j.item.jsonData);
                    }
                    catch { }
                    Globals.processResultObject(j.examination);
                    this.setState({ item: j.item, loaded: true });
                    this.loadOrder(j.item.orderID);
                }
                else if (j.errorCode) {
                    this.alert(j.errorMessage);
                    this.setState({ loaded: true });
                }
            });
        }
    }

    getRiskColor(risk) {
        if(risk === 'acute')
            return 'bg-warning';
        else if(risk === 'chronic')
            return 'bg-danger';
        else if(!risk)
            return 'bg-secondary';
        else
            return 'bg-dark';
    }

    render() {
        const header = <h1><L>Examinations</L></h1>;

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        const patientID = this.props.params.patientID;

        if (!this.state.patient)
            return <></>;

        const nowIdent = Globals.toDateOnlyString(new Date());

        return <div className="container-fluid">
            {header}
            <Breadcrumb path={this.props.params.examinationID ? [['Residents', '/examination/list'], [this.state.patient.name, '/examination/view/' + this.state.patient.id] ,['Examination']] : [['Residents', '/examination/list'], [this.state.patient.name]]} />
            {this.state.patient ? <Patient title="Patient" item={this.state.patient} readOnly /> : ''}
            {!this.props.params.examinationID ? 
                <Card title="Examinations">
                    {this.state.patient.lastExamDateIdent !== nowIdent ?
                    <div className="btn-group mb-2">
                        <Link to={'/examination/view/' + this.props.params.patientID + '/0'} role="button" className="btn btn-primary btn-lg">
                            <FontAwesomeIcon icon={faPlus} /><L>Start New Examination</L></Link>
                    </div> : ''}
                    {this.state.list.map(i => <Link key={i.id} to={'/examination/view/' + this.props.params.patientID + '/' + i.id} role="button" className="d-block rounded data-link bg-white p-3 mt-2">
                        <div>
                            <strong>{Globals.toMDYLocalDateString(i.createdDate)}</strong>
                            {Globals.toDateOnlyString(i.createdDate) === nowIdent ? <i><L>Today</L></i> : ''}
                        </div>
                        <small className={'badge text-capitalize ' + this.getRiskColor(i.riskTab)}>{i.riskTab ?? 'Not Classified'}</small>
                    </Link>)}
                </Card> :
                this.state.patient.examinationCount === 0 ? <Tabs
                    activeKey={this.props.params.tab}
                    defaultActiveKey={this.props.params.tab}
                    onSelect={(k) => { this.props.navigate('/examination/view/' + this.props.params.patientID + '/' + this.props.params.examinationID + '/' + k); }}
                    id="c-examinationpatient-tabs"
                    animation="false"><Tab eventKey="initial" title="Initial Assessment">
                        <Examination item={this.state.item} patientID={patientID} tab="initial" />
                    </Tab></Tabs> : <Tabs
                        activeKey={this.props.params.tab}
                        defaultActiveKey={this.props.params.tab}
                        onSelect={(k) => { this.props.navigate('/examination/view/' + this.props.params.patientID + '/' + this.props.params.examinationID + '/' + k); }}
                        id="c-examinationpatient-tabs"
                        animation="false">
                    <Tab eventKey="low" title="Low Risk">
                        <Examination item={this.state.item} patientID={patientID} tab="low" />
                    </Tab>
                    <Tab eventKey="high" title="High Risk">
                        <Examination item={this.state.item} patientID={patientID} tab="high" />
                    </Tab>
                    <Tab eventKey="acute" title="Acute">
                        <Examination item={this.state.item} patientID={patientID} tab="acute" />
                    </Tab>
                    <Tab eventKey="chronic" title="Chronic">
                        <Examination item={this.state.item} patientID={patientID} tab="chronic" />
                    </Tab></Tabs>}
        </div>;
    }
}

export default withParamsAndNavigate(ExaminationPatient);